import React, { FC } from "react";
import { useTheme } from "styled-components";
import { MenuItem, MenuItemOption } from "./styled.components";
import RecentSearchesSvg from "assets/icons/recentSearchesSvg";
import { IAutoCompleteItems } from "models/autocomplete";
import {gtmSearchBtnHeader, gtmSearchForUserName} from "GTMs/actions/commonActions";
import IconLeftArrowHead from "assets/icons/IconLeftArrowHead";

interface IProps {
  suggestions: IAutoCompleteItems[];
  handleSearchListItem: (val: IAutoCompleteItems) => void;
  suggestionIndex: number;
  currentValue?: string;
}

const SearchSuggestions: FC<IProps> = ({
  suggestions,
  handleSearchListItem,
  suggestionIndex,
  currentValue,
}) => {
  const { colors, translations } = useTheme();
  const containsOnlyNumbers = /^\d+$/.test(currentValue);

  return (
    <MenuItem className="suggestions absolute width-100 whiteBg">
      {!containsOnlyNumbers && (
      <a
        className="blackColor"
        href={`/search-for-user-name?userName=${currentValue}`}>
        <div
          id="searchByNameDesktop"
          className="flex flexSpaceBetween mt-8 mb-8 pointer"
          onClick={()=>gtmSearchForUserName()}>
          <div className="flex alignItems ms-8">
            <RecentSearchesSvg
              width="20"
              height="20"
              className="me-8"
              fill={colors.BlueLight}
            />
            <span className="font-14">
              {translations.header.searchByUserName}
              {currentValue && (
                <strong className="ms-8 blueColor">{currentValue}</strong>
              )}
            </span>
          </div>
          <IconLeftArrowHead />
        </div>
      </a>
      )}

      {suggestions &&
        suggestions.map((suggestion, index) => {
          return (
            <MenuItemOption
              className="flex alignItem p-8 pointer searchAutocompleteSourceDesktop"
              highlight={index === suggestionIndex}
              key={index}
              onClick={() => handleSearchListItem(suggestion)}
            >
              <RecentSearchesSvg
                width="20"
                height="20"
                className="me-8"
                fill={colors.BlueLight}
              />
              <span
                id={`text${index}`}
                className="font-14"
                onClick={gtmSearchBtnHeader}
              >
                {suggestion.label}
              </span>
            </MenuItemOption>
          );
        })}
    </MenuItem>
  );
};

export default SearchSuggestions;
